export default "__VITE_ASSET__DiWeOCe0__"